<template>
  <div class="cart-page pb-12">
    <ServerError v-if="ServerError" />
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />

    <v-snackbar v-model="showSnackBar" color="#3EA56E" right timeout="2000" class="mt-12">
      <div class="d-flex align-center">
        <v-icon color="white" class="mr-2">mdi-check-circle</v-icon>
        <span class="ibmmedium">{{ msg }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="showSnackBar = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-container class="mt-8 mt-md-4 pt-4 pt-md-0">
      <v-layout wrap v-if="cart && cart.length > 0">
        <!-- Main Cart Content -->
        <v-flex xs12 lg8 class="pr-lg-6">
          <div class="cart-header d-flex align-center mb-6">
            <v-icon color="#3EA56E" class="mr-3" size="28">mdi-cart-outline</v-icon>
            <h1 class="page-title">Shopping Cart ({{ cartCount }} items)</h1>
          </div>
          <v-divider class="title-divider mb-8"></v-divider>

          <!-- Delivery Address Section -->
          <div v-if="appLogin" class="mb-8">
            <div class="d-flex align-center justify-space-between flex-wrap mb-4">
              <span class="section-subtitle">Delivery Address</span>
              <v-btn text color="#3EA56E" class="text-none ibmsemibold px-0 mt-1" @click="adddialog = true">
                <v-icon left>mdi-plus</v-icon>
                Add New Address
              </v-btn>
            </div>

            <div v-if="address1 && address1.length > 0">
              <v-card v-for="(item2, i) in address1" :key="i" flat class="address-card mb-3" :class="{ 'active-address': radios === item2._id }">
                <div class="d-flex align-start pa-3 pa-sm-4">
                  <!-- Custom Radio Container -->
                  <div class="mr-3 pt-1">
                    <v-radio-group v-model="radios" hide-details class="ma-0 pa-0">
                      <v-radio
                        color="#3EA56E"
                        :value="item2._id"
                        @click="setDefaultAddress(item2._id)"
                      ></v-radio>
                    </v-radio-group>
                  </div>

                  <!-- Address Content -->
                  <div class="flex-grow-1 text-left">
                    <div class="d-flex align-start justify-space-between mb-2">
                      <span class="customer-name pr-2">{{ item2.firstname }} {{ item2.lastname }}</span>
                      <div class="address-actions d-flex no-wrap">
                        <v-btn icon small color="#64748b" @click="(curItem = JSON.parse(JSON.stringify(item2))), (editdialog = true)">
                          <v-icon size="18">mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn icon small color="#ef4444" @click="(dialoge = true), (curId = item2._id)">
                          <v-icon size="18">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div class="address-details">
                      <p class="address-text mb-1">
                        {{ item2.streetAddress }}, {{ item2.locality }}, {{ item2.city }}
                      </p>
                      <p class="address-text mb-1">
                        {{ item2.state }}, {{ item2.country }} - {{ item2.pincode }}
                      </p>
                      <p class="address-text ibmmedium color-dark mt-2">Ph: {{ item2.delphone }}</p>
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
            
            <v-card v-else flat class="empty-address-card d-flex align-center justify-center pa-8 border-dashed">
              <v-btn tile depressed color="#3EA56E" dark class="ibmsemibold rounded-lg px-6" @click="adddialog = true">
                <v-icon left>mdi-map-marker-plus</v-icon>
                Add Delivery Address
              </v-btn>
            </v-card>
          </div>

          <!-- Cart Items List -->
          <div class="cart-items-section">
            <h3 class="section-subtitle mb-4">Items in Cart</h3>
            <v-card flat v-for="(item, i) in cart" :key="i" class="cart-item-card mb-4">
              <v-layout wrap align-center class="pa-4">
                <!-- Product Thumbnail -->
                <v-flex xs12 sm3 md2 class="pr-sm-4 mb-4 mb-sm-0 text-center">
                  <div class="product-thumb-container">
                    <template v-if="item.productId.photos && item.productId.photos.length > 0">
                      <v-img
                        :src="mediaURL + item.productId.photos[0]"
                        class="rounded-lg product-thumb"
                        height="100"
                        contain
                        @click="$router.push('/productdetailview/' + item.productId.urlname)"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="#3EA56E"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </template>
                    <template v-else>
                      <v-img
                        :src="require('../../../assets/noimg.png')"
                        class="rounded-lg product-thumb"
                        height="100"
                        contain
                        @click="$router.push('/productdetailview/' + item.productId.urlname)"
                      >
                      </v-img>
                    </template>
                    <div class="out-of-stock-label" v-if="item.productId.status == 'Inactive' || item.productId.quantity < 1">
                      <span>OUT OF STOCK</span>
                    </div>
                  </div>
                </v-flex>

                <!-- Product Details -->
                <v-flex xs12 sm5 md6>
                  <div class="text-sm-left text-center">
                    <h4 class="cart-item-name mb-1" @click="$router.push('/productdetailview/' + item.productId.urlname)">
                      {{ item.productId.productname }}
                    </h4>
                    <div class="cart-item-price-info d-flex align-center justify-center justify-sm-start">
                      <span class="item-current-price">₹{{ item.totalOfferPrice }}</span>
                      <span class="item-old-price ml-2">₹{{ item.totalPrice }}</span>
                    </div>
                  </div>
                </v-flex>

                <!-- Quantity and Remove -->
                <v-flex xs12 sm4 md4 class="mt-4 mt-sm-0">
                  <div class="d-flex flex-column align-end justify-center">
                    <div v-if="item.productId.quantity < 1" class="mb-2">
                       <span class="oos-text">Unavailable</span>
                    </div>
                    <div v-else class="qty-selector d-flex align-center mb-2">
                      <v-btn
                        icon
                        small
                        class="qty-btn"
                        @click="editCart(item, item.quantity - 1)"
                        :disabled="item.quantity <= item.productId.minimumOrderQuantity || item.productId.status !== 'Active'"
                      >
                        <v-icon size="18">mdi-minus</v-icon>
                      </v-btn>
                      <span class="qty-value mx-4">{{ item.quantity }}</span>
                      <v-btn
                        icon
                        small
                        class="qty-btn"
                        @click="editCart(item, item.quantity + 1)"
                        :disabled="item.quantity >= item.productId.maxOrderQuantity || item.productId.status !== 'Active'"
                      >
                        <v-icon size="18">mdi-plus</v-icon>
                      </v-btn>
                    </div>
                    <v-btn icon color="#ef4444" @click="removeCart(item.productId)" class="remove-cart-btn">
                      <v-icon size="18">mdi-delete-outline</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </div>
        </v-flex>

        <!-- Order Summary Sidebar -->
        <v-flex xs12 lg4 mt-12 mt-lg-0>
          <v-card flat class="summary-card sticky-sidebar pa-6">
            <h2 class="section-subtitle mb-6 pb-2 border-bottom">Price Details</h2>
            
            <div class="d-flex justify-space-between mb-4">
              <span class="summary-label">Price ({{ cartCount }} items)</span>
              <span class="summary-value">₹{{ total }}</span>
            </div>
            
            <!-- <div class="d-flex justify-space-between mb-4">
              <span class="summary-label">Delivery Charges</span>
              <span class="summary-value green--text">FREE</span>
            </div> -->
            
            <v-divider class="my-6"></v-divider>
            
            <div class="d-flex justify-space-between mb-8">
              <span class="total-label">Total Amount</span>
              <span class="total-value">₹{{ total }}</span>
            </div>

            <div v-if="appLogin">
              <v-btn
                v-if="address1.length <= 0"
                block
                depressed
                large
                color="#3EA56E"
                dark
                class="place-order-btn py-6"
                @click="adddialog = true"
              >
                Place Order
              </v-btn>
              <v-btn
                v-else
                block
                depressed
                large
                color="#3EA56E"
                dark
                class="place-order-btn py-6"
                :disabled="buttonStatus.length < 1 || buttonStatus2.length < 1"
                @click="validateInput()"
              >
                Checkout Now
              </v-btn>
            </div>
            <v-btn
              v-else
              block
              depressed
              large
              color="#3EA56E"
              dark
              class="place-order-btn py-6"
              @click="$router.push('/login')"
            >
              Login to Checkout
            </v-btn>

            <p class="safeguard-text mt-4 text-center">
              <v-icon x-small color="#64748b" class="mr-1">mdi-shield-check</v-icon>
              Safe and Secure Payments. 100% Authentic products.
            </p>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- Empty Cart State -->
      <v-layout wrap justify-center v-else-if="!appLoading" class="py-16">
        <v-flex xs12 md6 text-center>
          <div class="empty-cart-container pa-12">
            <v-icon size="100" color="#e2e8f0" class="mb-6">mdi-cart-remove</v-icon>
            <h2 class="empty-title mb-3">Your cart is empty!</h2>
            <p class="empty-description mb-8">It's a great day to buy the products you've been eyeing. Add items to your cart and make them yours!</p>
            
            <template v-if="!appLogin">
              <p class="login-msg mb-6">Login to see the items you added previously</p>
              <v-btn
                color="#3EA56E"
                dark
                depressed
                x-large
                @click="$router.push('/login')"
                class="explore-btn px-10 rounded-lg"
              >
                Login
              </v-btn>
            </template>
            <v-btn
              v-else
              color="#3EA56E"
              dark
              depressed
              x-large
              to="/products"
              class="explore-btn px-10 rounded-lg"
            >
              Start Shopping
            </v-btn>
          </div>
        </v-flex>
      </v-layout>

        <v-dialog v-model="adddialog" max-width="600px" overlay-color="#1a202c" overlay-opacity="0.5">
          <v-form ref="form">
            <v-card class="rounded-xl overflow-hidden">
              <v-card-title class="pa-6 border-bottom">
                <v-icon color="#3EA56E" class="mr-3">mdi-map-marker-plus-outline</v-icon>
                <span class="dialog-title">Add New Address</span>
              </v-card-title>
              
              <v-card-text class="pa-6 pt-8">
                <v-layout wrap>
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.firstname"
                      label="First Name"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.required]"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.lastname"
                      label="Last Name"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.required]"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 px-2>
                    <v-text-field
                      v-model="user.streetAddress"
                      label="Street Address"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.required]"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.locality"
                      label="Locality / Landmark"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.required]"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.city"
                      label="City / Town"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.required]"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 px-2 class="d-flex align-center">
                    <v-checkbox
                      v-model="user.isInsideKerala"
                      label="Is Delivery Inside Kerala?"
                      color="#3EA56E"
                      hide-details
                      class="mb-2 mt-2 pt-0"
                      @change="handleInsideKeralaAddChange"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.district"
                      label="District"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.required]"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.state"
                      label="State"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.required]"
                      class="custom-field"
                      :disabled="user.isInsideKerala"
                    ></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.country"
                      label="Country"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.required]"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.pincode"
                      type="number"
                      label="Pincode"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="pinRules"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.delphone"
                      label="Mobile Number"
                      type="number"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="phoneRules"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm="6" px-2>
                    <v-text-field
                      v-model="user.email"
                      label="Email Address"
                      outlined
                      dense
                      color="#3EA56E"
                      :rules="[rules.email]"
                      class="custom-field"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              
              <v-divider></v-divider>
              
              <v-card-actions class="pa-6">
                <v-spacer></v-spacer>
                <v-btn text color="#64748b" class="text-none ibmsemibold px-6" @click="adddialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  v-if="!flag"
                  depressed
                  color="#3EA56E"
                  dark
                  class="text-none ibmsemibold px-8 rounded-lg"
                  @click="addAddress()"
                >
                  Save Address
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="editdialog" max-width="600px" overlay-color="#1a202c" overlay-opacity="0.5">
          <v-card class="rounded-xl overflow-hidden" v-if="curItem">
            <v-card-title class="pa-6 border-bottom">
              <v-icon color="#3EA56E" class="mr-3">mdi-map-marker-edit-outline</v-icon>
              <span class="dialog-title">Edit Delivery Address</span>
            </v-card-title>
            
            <v-card-text class="pa-6 pt-8">
              <v-layout wrap>
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.firstname"
                    label="First Name"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.required]"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.lastname"
                    label="Last Name"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.required]"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
                
                <v-flex xs12 px-2>
                  <v-text-field
                    v-model="curItem.streetAddress"
                    label="Street Address"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.required]"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
                
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.locality"
                    label="Locality / Landmark"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.required]"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.city"
                    label="City / Town"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.required]"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
                
                <v-flex xs12 px-2 class="d-flex align-center">
                  <v-checkbox
                    v-model="curItem.isInsideKerala"
                    label="Is Delivery Inside Kerala?"
                    color="#3EA56E"
                    hide-details
                    class="mb-2 mt-2 pt-0"
                    @change="handleInsideKeralaEditChange"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.district"
                    label="District"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.required]"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.state"
                    label="State"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.required]"
                    class="custom-field"
                    :disabled="curItem.isInsideKerala"
                  ></v-text-field>
                </v-flex>
                
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.country"
                    label="Country"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.required]"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.pincode"
                    type="number"
                    label="Pincode"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="pinRules"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.delphone"
                    label="Mobile Number"
                    type="number"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="phoneRules"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm="6" px-2>
                  <v-text-field
                    v-model="curItem.email"
                    label="Email Address"
                    outlined
                    dense
                    color="#3EA56E"
                    :rules="[rules.email]"
                    class="custom-field"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="pa-6">
              <v-spacer></v-spacer>
              <v-btn text color="#64748b" class="text-none ibmsemibold px-6" @click="editdialog = false">
                Cancel
              </v-btn>
              <v-btn
                depressed
                color="#3EA56E"
                dark
                class="text-none ibmsemibold px-8 rounded-lg"
                @click="editAddress(curItem._id)"
              >
                Update Address
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="450px" v-model="dialoge" overlay-color="#1a202c" overlay-opacity="0.5">
          <v-card class="rounded-xl overflow-hidden pa-4">
            <v-card-title class="d-flex flex-column align-center pt-8 pb-4">
              <v-icon color="#ef4444" size="64" class="mb-4">mdi-alert-circle-outline</v-icon>
              <h2 class="dialog-title text-center">Confirm Deletion</h2>
            </v-card-title>
            
            <v-card-text class="text-center pb-8 px-8">
              <p class="empty-description">Are you sure you want to remove this address? This action cannot be undone.</p>
            </v-card-text>
            
            <v-card-actions class="d-flex flex-column pb-8 px-8">
              <v-btn
                depressed
                block
                large
                color="#ef4444"
                dark
                class="text-none ibmsemibold rounded-lg mb-4 py-6"
                @click="deleteAddress(curId)"
              >
                Yes, Delete
              </v-btn>
              <v-btn text block large color="#64748b" class="text-none ibmsemibold rounded-lg" @click="dialoge = false">
                Wait, Keep it
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      buttonStatus: [],
      buttonStatus2: [],

      cart: [],
      address1: [],
      curItem: null,
      cartCount: null,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      adddialog: false,
      editdialog: false,
      dialoge: false,
      curId: null,
      flag: null,
      total: null,
      msg: null,
      radios: 1,
      radios2: false,
      address: {
        country: null,
        state: null,
        district: null,
        firstname: null,
        lastname: null,
        pincode: null,
        streetAddress: null,
        locality: null,
        city: null,
        delphone: null,

        email: null,
      },
      user: {
        isInsideKerala: true,
        country: null,
        state: 'Kerala',
        district: null,
        firstname: null,
        lastname: null,
        pincode: null,
        streetAddress: null,
        locality: null,
        city: null,
        delphone: null,
        email: null,
      },
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        minPhone: (value) => value.length == 10 || "Invalid Phone",
        //  pincode: (value) => value.length == 6 || "Please provide valid pincode",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) =>
          (v && v.length <= 10) || "number must be less than 11 characters",
        (v) =>
          (v && v.length >= 10) || "number must be greater than 10 characters",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],
      pinRules: [
        (v) => !!v || "Pincode is Required",
        (v) => /^(\d{4}|\d{6})$/.test(v) || "Pincode must be valid",
      ],
    };
  },
  mounted() {
    this.setMetaTags();
    this.getData();
    this.getAddress();
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
  },
  watch: {
    radios() {
      localStorage.setItem("address", this.radios);
    },
    adddialog(val) {
      if (val) {
        if (typeof this.user.isInsideKerala === 'undefined') {
          this.$set(this.user, 'isInsideKerala', true);
        }
        if (!this.user.state && this.user.isInsideKerala) {
          this.$set(this.user, 'state', 'Kerala');
        }
      }
    },
    editdialog(val) {
      if (val && this.curItem) {
        let isInside = this.curItem.isInsideKerala;
        if (typeof isInside === 'undefined') {
          isInside = (this.curItem.state === 'Kerala' || this.curItem.state === 'kerala');
        }
        this.$set(this.curItem, 'isInsideKerala', isInside);
        if (isInside) {
          this.curItem.state = 'Kerala';
        }
      }
    },
  },
  methods: {
    setMetaTags() {
      document.title = "Shopping Cart & Checkout | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "Review your items and proceed to securely checkout at KL-06 FARM.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    handleInsideKeralaAddChange(val) {
      if (val) {
        this.user.state = 'Kerala';
      } else {
        if (this.user.state === 'Kerala') this.user.state = '';
      }
    },
    handleInsideKeralaEditChange(val) {
      if (val) {
        this.curItem.state = 'Kerala';
      } else {
        if (this.curItem.state === 'Kerala') this.curItem.state = '';
      }
    },
    // validate() {
    //   this.$refs.form.validate();
    // },
    // resetValidation() {
    //   this.$refs.form.resetValidation();
    // },
    validateInput() {
      if (!this.radios || !this.address1) {
        this.msg = "Please select a delivery address";
        this.showSnackBar = true;
        return;
      } else this.placeOrder();
    },
    placeOrder() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/placeorder/address/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          deliveryaddressId: this.radios,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push({path:"/confirmAddress",
            query:{
              id:this.radios
            }});
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
          this.getData();
          this.total = response.data.total;
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      console.log("guest id=",localStorage.getItem("guestId"))
       var headers1 = {};
      var data = {};
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else data["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "POST",
        url: "/Cart/Getlist",
          data: data,
        headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          this.cart = response.data.cart;

          this.cartCount = response.data.cart_length;
          if (this.cart.photo) this.photos = this.cart.productId.photos;
          this.total = response.data.total;

          this.buttonStatus = this.cart.filter(checkStatus);

          function checkStatus(value) {
            if (value.productId.status == "Active") {
              return value;
            }
          }
          this.buttonStatus2 = this.cart.filter(checkStatus2);

          function checkStatus2(value) {
            if (value.productId.quantity > 0) {
              return value;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    removeCart(item) {
      var data = {};
      var headers1 = {};
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "post",
        url: "/Cart/Remove/" + item._id,
        headers: headers1,
        data: data,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.$store.commit("changeCart", response.data.cartLength);
            // this.$router.push("/cart");
            // setTimeout(() => this.$router.go(), 3000);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
            // if (this.snackbar == false) {
            //   this.$router.go();
            // }
            // setTimeout(() => this.$router.go(), 3000);
          }
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    userData() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/user/info",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.cart = response.data.cart;
          if (this.cart.photo) this.photos = this.cart.productId.photos;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addAddress() {
      if (this.$refs.form.validate()) {
        this.appLoading = true;
        axios({
          method: "post",
          url: "/deliveryaddress/add",
          data: this.user,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status == true) {
              localStorage.removeItem("address");
              this.msg = response.data.msg;
              this.showsnackbar = true;
              this.adddialog = false;
              this.user = {};
              console.log(response.data.id)
              localStorage.setItem("address", response.data.id);
              console.log("set id")
              this.radios = localStorage.getItem("address");
              console.log("get id")
              this.getAddress();
              console.log("call getaddress")
              //  this.cart = response.data.cart;
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
            // this.cart = response.data.cart;
            // if(this.cart.photo)
            // this.photos = this.cart.productId.photos;
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    getAddress() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.address1 = response.data.data.deliveryaddress;

          console.log("this.address1", this.address1);

          this.address.id = response.data.data._id;

          if (localStorage.getItem("address")) {
            this.radios = localStorage.getItem("address");
             console.log("if issssss workinggg")
            // this.address.id = this.radios;
          } 
          else {

            console.log("im workinggg")
            if (this.address1.length > 0) {
              this.radios = this.address1[this.address1.length - 1]._id;
              console.log("this.radios=", this.radios);
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    setDefaultAddress(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          deliveryaddressindex: item,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            // this.msg = response.data.msg;
            this.msg = "Shipping Address Changed";
            this.showSnackBar = true;
            this.getProfile();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.radios = response.data.data.deliveryaddressindex;
            localStorage.setItem("address", this.radios);
            // for (var i = 0; i < this.address.length; i++) {
            //   if (
            //     response.data.data.deliveryaddressindex == this.address[i]._id
            //   ) {
            //     this.defaultAddress = this.address[i];
            //     // this.defaultAddress =localStorage.getItem("address");
            //     // console.log(this.defaultAddress)
            //   }
            // }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editAddress(item) {
      this.curItem.id = item;
      this.appLoading = true;
      axios({
        method: "post",
        url: "/deliveryaddress/edit",
        data: this.curItem,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.editdialog = false;
            //  this.cart = response.data.cart;
            this.getAddress();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    //delete button
    deleteAddress(item) {
      axios({
        url: "/deliveryaddress/remove",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item,
        },
      })
        .then((response) => {
          this.delete = false;
          this.dialoge = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            // this.$router.go(-1)
            this.showsnackbar = true;
            var existingAddress = localStorage.getItem("address");
            if (item == existingAddress) {
              localStorage.removeItem("address");
            }
            this.getAddress();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editCart(item, qty) {
      this.appLoading = true;
      var data = {
        quantity: qty,
        id: item.productId._id,
        type: "cart",
      };
      var headers1 = {};
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "post",
        url: "/cart/edit",
        data: data,
        headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getData();
            // this.editdialog = false;
            //  this.cart = response.data.cart;
            this.getAddress();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.cart-page {
  background-color: #f8fafc;
  min-height: 100vh;
}

.page-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 26px;
  color: #1a202c;
  margin: 0;
}

.title-divider {
  border-color: #3EA56E;
  max-width: 60px;
  border-width: 3px;
  opacity: 1;
}

.section-subtitle {
  font-family: "ibmsemibold", sans-serif;
  font-size: 18px;
  color: #334155;
}

/* Address Cards */
.address-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px !important;
  transition: all 0.2s ease;
}

.active-address {
  border-color: #3EA56E;
  background-color: #f0fdf4 !important;
}

.customer-name {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px;
  color: #1a202c;
}

.address-text {
  font-family: "sofialight", sans-serif;
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.border-dashed {
  border: 2px dashed #cbd5e1 !important;
  border-radius: 12px !important;
}

/* Cart Items */
.cart-item-card {
  border: 1px solid #e2e8f0;
  border-radius: 16px !important;
  background: #ffffff;
}

.product-thumb-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.product-thumb {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.product-thumb:hover {
  transform: scale(1.03);
}

.out-of-stock-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 12px;
  border-radius: 4px;
  z-index: 2;
}

.out-of-stock-label span {
  color: #ef4444;
  font-family: "ibmsemibold", sans-serif;
  font-size: 10px;
  white-space: nowrap;
}

.cart-item-name {
  font-family: "ibmsemibold", sans-serif;
  font-size: 17px;
  color: #1e293b;
  cursor: pointer;
}

.item-current-price {
  font-family: "ibmsemibold", sans-serif;
  font-size: 18px;
  color: #3EA56E;
}

.item-old-price {
  font-family: "sofialight", sans-serif;
  font-size: 14px;
  color: #94a3b8;
  text-decoration: line-through;
}

/* Qty Selector */
.qty-selector {
  background: #f1f5f9;
  border-radius: 8px;
  padding: 2px;
}

.qty-btn {
  background: #ffffff !important;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.qty-value {
  font-family: "ibmsemibold", sans-serif;
  font-size: 15px;
  min-width: 24px;
  text-align: center;
}

.oos-text {
  color: #ef4444;
  font-family: "ibmmedium", sans-serif;
  font-size: 14px;
}

/* Summary Card */
.summary-card {
  border: 1px solid #e2e8f0;
  border-radius: 20px !important;
  background: #ffffff;
}

.sticky-sidebar {
  position: sticky;
  top: 100px;
}

.summary-label {
  font-family: "sofialight", sans-serif;
  font-size: 15px;
  color: #64748b;
}

.summary-value {
  font-family: "ibmmedium", sans-serif;
  font-size: 15px;
  color: #1e293b;
}

.total-label {
  font-family: "ibmsemibold", sans-serif;
  font-size: 19px;
  color: #1e293b;
}

.total-value {
  font-family: "ibmsemibold", sans-serif;
  font-size: 22px;
  color: #1e293b;
}

.place-order-btn {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px !important;
  text-transform: none !important;
  border-radius: 12px !important;
}

.safeguard-text {
  font-family: "sofialight", sans-serif;
  font-size: 11px;
  color: #94a3b8;
}

.border-bottom {
  border-bottom: 1px solid #f1f5f9;
}

/* Empty State */
.empty-cart-container {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
}

.empty-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 24px;
  color: #334155;
}

.empty-description {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #64748b;
}

.login-msg {
  font-family: "ibmmedium", sans-serif;
  color: #475569;
  font-size: 15px;
}

.explore-btn {
  font-family: "ibmsemibold", sans-serif;
  text-transform: none !important;
  letter-spacing: 0.5px;
}

.ibmmedium {
  font-family: "ibmmedium", sans-serif;
}

.qty-btn {
  background-color: #f1f5f9 !important;
  color: #3EA56E !important;
  border-radius: 8px !important;
}

.color-dark {
  color: #1e293b !important;
}

.qty-btn:hover {
  background-color: #e2e8f0 !important;
}

.qty-value {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px;
  color: #1e293b;
}

.remove-cart-btn {
  background-color: #fef2f2 !important;
}

.remove-cart-btn:hover {
  background-color: #fee2e2 !important;
}

.address-details {
  line-height: 1.6;
}

.dialog-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #1a202c;
}

.custom-field >>> .v-label {
  font-family: "sofialight", sans-serif;
  font-size: 14px;
}

.custom-field >>> input {
  font-family: "ibmmedium", sans-serif;
  font-size: 15px;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 20px;
  }
  
  .section-subtitle {
    font-size: 16px;
  }
  
  .customer-name {
    font-size: 15px;
  }
  
  .address-card {
    border-radius: 12px !important;
  }
  
  .v-container {
    padding: 12px !important;
  }
}

@media (max-width: 960px) {
  .sticky-sidebar {
    position: static;
  }
}
</style>